import i18n from "i18next";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";
import enCommon from "./en/common.json";
import ruCommon from "./ru/common.json";
import tkCommon from "./tk/common.json";

const LANG_STORAGE_KEY = "awtoban.hq.locale";

export type Locale = "tk" | "ru" | "en";

export function getStoredLocale(): Locale {
  if (typeof window === "undefined") return "tk";
  const v = window.localStorage.getItem(LANG_STORAGE_KEY);
  return v === "tk" || v === "ru" || v === "en" ? v : "tk";
}

export function setStoredLocale(locale: Locale): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LANG_STORAGE_KEY, locale);
}

await i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    resources: {
      tk: { common: tkCommon },
      ru: { common: ruCommon },
      en: { common: enCommon },
    },
    lng: getStoredLocale(),
    fallbackLng: "tk",
    defaultNS: "common",
    interpolation: { escapeValue: false }, // React already escapes
  });

export default i18n;
